import { Container, Table } from "react-bootstrap";
import MainMenu from "../../modules/public/mainMenu/mainMenu";
import { useQuery } from "@tanstack/react-query";
import { getAuthMethod } from "../../modules/helper";
import Laoder from "../../components/loading/Loader";
import jalaliTime from "../../functions/jalaliTime";

function Supervisors() {
  const { isLoading, data } = useQuery({
    queryKey: ["districtManager-supervisors"],
    queryFn: () =>
      getAuthMethod("/district-manager/v1/supervisors").then(
        res => res.data.result
      ),
    refetchOnWindowFocus: false,
    initialData: [],
  });

  return (
    <MainMenu>
      <Container>
        <h4>لیست استان ها و سرپرست ها</h4>
        <section className="w-100 px-1 overflow-x-auto mt-4">
          <Table className="text-center" striped={true} bordered={true}>
            <thead>
              <tr>
                <th>ردیف</th>
                <th>استان</th>
                <th>نام سرپرست</th>
                <th>کد ملی سرپرست</th>
                <th>موبایل سرپرست</th>
                <th>آدرس سرپرست</th>
                <th>تاریخ</th>
              </tr>
            </thead>
            <tbody>
              {isLoading === true && (
                <tr>
                  <td colSpan="8">
                    <Laoder />
                  </td>
                </tr>
              )}
              {isLoading === false &&
                data?.map((item, idx) => (
                  <tr key={item.id} className="align-middle">
                    <td>{idx + 1}</td>
                    <td>{item.faName}</td>
                    <td>
                      <span>{item.supervisor?.user.name}</span>
                      <span> {item.supervisor?.user.family}</span>
                    </td>
                    <td>{item.supervisor?.user.nationalCode}</td>
                    <td>{item.supervisor?.user.phone}</td>
                    <td>
                      <span>
                        {item.supervisor?.user.location.province.faName}
                      </span>
                      <span> {item.supervisor?.user.location.city.faName}</span>
                      <span> {item.supervisor?.user.location.address}</span>
                    </td>
                    <td>
                      <span className="enable-n">
                        {jalaliTime(item.created_at).full}
                      </span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </section>
      </Container>
    </MainMenu>
  );
}

export default Supervisors;
